export const FILES = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
export const RANKS = ['1', '2', '3', '4', '5', '6', '7', '8'];
export function isSquare(s) {
    return /^[a-h][1-8]$/.test(s);
}
export const ALL_SQUARES = (() => {
    const out = [];
    for (const f of FILES)
        for (const r of RANKS)
            out.push(`${f}${r}`);
    return out;
})();
export function fileIndex(s) {
    return s.charCodeAt(0) - 'a'.charCodeAt(0);
}
export function rankIndex(s) {
    return s.charCodeAt(1) - '1'.charCodeAt(0);
}
export function squareAt(fileIdx, rankIdx) {
    if (fileIdx < 0 || fileIdx > 7 || rankIdx < 0 || rankIdx > 7)
        return null;
    const f = String.fromCharCode('a'.charCodeAt(0) + fileIdx);
    const r = String.fromCharCode('1'.charCodeAt(0) + rankIdx);
    return `${f}${r}`;
}
